import assetPath from '/app/packages/entity-pages/entity-pages-location/src/assets/mapIcon.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')